import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  getFinancialYearOptions,
  getStoredFinancialYear,
  isAllowedFinancialYear,
  storeFinancialYear,
  type FinancialYearOption,
} from '../../shared/utils/financial-year.utils';

@Injectable({
  providedIn: 'root',
})
export class FinancialYearFilterService {
  readonly options: FinancialYearOption[] = getFinancialYearOptions();
  private readonly selectedYearSubject = new BehaviorSubject<number | null>(
    this.resolveInitialYear()
  );

  readonly selectedYear$ = this.selectedYearSubject.asObservable();

  get selectedYear(): number | null {
    return this.selectedYearSubject.value;
  }

  get selectedYearValue(): string {
    const year = this.selectedYearSubject.value;
    return year == null ? 'all' : String(year);
  }

  setSelectedYear(year: number | null): void {
    if (year != null && !isAllowedFinancialYear(year)) {
      return;
    }
    if (year != null && (!Number.isFinite(year) || year <= 0)) {
      return;
    }
    storeFinancialYear(year);
    this.selectedYearSubject.next(year);
  }

  private resolveInitialYear(): number | null {
    const storedYear = getStoredFinancialYear();
    if (storedYear == null) {
      return null;
    }

    if (!isAllowedFinancialYear(storedYear)) {
      storeFinancialYear(null);
      return null;
    }

    return storedYear;
  }
}
